/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnDemandTaskViewModel } from '../../models/on-demand-task-view-model';

export interface ListOnDemandTasks$Params {
}

export function ListOnDemandTasks(http: HttpClient, rootUrl: string, params?: ListOnDemandTasks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnDemandTaskViewModel>>> {
  const rb = new RequestBuilder(rootUrl, ListOnDemandTasks.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OnDemandTaskViewModel>>;
    })
  );
}

ListOnDemandTasks.PATH = '/api/Developer/ListOnDemandTasks';
